var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.87,
    x: 12.8787,
    y: 10.0503,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(135 12.8787 10.0503)",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 10,
    y: 13,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(90 10 13)",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.63,
    x: 10.0508,
    y: 17.1211,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(45 10.0508 17.1211)",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.51,
    x: 13,
    y: 20,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.39,
    x: 27.0234,
    y: 24.1924,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(135 27.0234 24.1924)",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.27,
    x: 30,
    y: 13,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(90 30 13)",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 24.1953,
    y: 2.97949,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(45 24.1953 2.97949)",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 4,
    height: 10,
    rx: 2,
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicSpinner);
export default __webpack_public_path__ + "static/media/magic-spinner.1880306f39df2e736eabe79aec0d2c77.svg";
export { ForwardRef as ReactComponent };